<template>

  <div class="summary_pnp">
    <div class="row px-2 mt-3">
      <div class="col-12 col-md-6 col-lg-3 mb-4">
        <div class="card p-2 border-card shadow">
          <p class="text-primary">{{ __("forms.EvaluationChart.questions.questions_setting.question18.general_avg")  }} {{pnp_summary_column_label}}</p>
          <p class="text-right h3">
            {{ avg_total_factors }}
          </p>
        </div>
      </div>
    </div>
    <h3 class="text-primary ml-2">
      {{ __("forms.EvaluationChart.questions.questions_setting.question18.card_calculation_title") }}
    </h3>
    <div class="row px-2 mt-3">
      <div
        class="col-12 col-md-6 col-lg-3 mb-3"
        v-for="(el, indexC) in Object.entries(numbers_summary).filter(
          (x) => x[0] !== 'total',
        )"
        :key="indexC"
      >
        <div class="card p-2 border-card shadow">
          <p class="text-primary">{{ __("views.Evaluation."+el[0])  }}</p>
          <p class="text-right h3">
            {{ el[1] || 0 }}
          </p>
        </div>
      </div>
    </div>


    <div class="row my-5 px-2">
      <div class="col-12">
        <h3 class="text-primary">
          {{ __("forms.EvaluationChart.questions.questions_setting.question18.avg_factors_graph") }} {{pnp_summary_column_label}}
        </h3>
      </div>
      <div class="col-12">
        <vertical-bar
          ref="vertical_bar_summary_pnp"
          :range="range_value"
          title_text=''
          :fixedLabelXAxis="true"
        ></vertical-bar>
        <p class="text-center small text-muted">
          {{ __("forms.EvaluationChart.questions.questions_setting.question18.mouse_hover") }}
        </p>
      </div>
    </div>

    <div class="row mb-3 px-2">
      <div class="col-12">
        <h3 class="text-primary">{{ __("forms.EvaluationChart.questions.questions_setting.question18.factors_and_indicators") }}</h3>
      </div>
    </div>

    <div class="row mb-3 px-2">
      <div class="col-12">
        <button class="btn btn--blue" @click="hideAll" type="button">
         {{ __("views.pnpQuestion.hideAll")}}
        </button>
        <button class="btn btn--blue" @click="showAll" type="button">
         {{ __("views.pnpQuestion.openAll")}}
        </button>
      </div>
    </div>

    <div
      class="row px-2 mb-1"
      v-for="(factor, indexF) in table_summary_structure"
      :key="indexF"
    >
      <div class="col-12">
        <button
          type="button"
          class="btn w-100 justify-content-between mb-3"
          @click="toggle(indexF)"
        >
          {{ factor.name }}
          <i :ref="'chevron' + indexF" class="fas fa-chevron-up"></i>
        </button>
      </div>
      <div :ref="`summary_drop${indexF}`" class="col-12">
        <div class="row px-2">
          <div
            class="col-12 col-md-6 col-lg-3 mb-3"
            v-for="(column, indexC) in columns"
            :key="indexC"
          >
            <div class="card p-2 border-card shadow">
              <p class="text-primary">{{ column.name }}</p>
              <p class="text-right h3">
                {{
                  factors_summary[column.type][indexF]["final_value"][
                    column.element
                  ] || "&nbsp;"
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="row px-2">
          <div class="table--custom my-3">
            <div class="single--row single--row-input">
              <div
                class="single--row-input-content"
                style="background-color: #559bd9"
              >
                <div class="row">
                  <div :class="'col-lg-' + colMdIndicator + ' col-md-2 col-12'">
                    <div class="single--row-info border-0">
                      &nbsp; &nbsp; &nbsp;
                    </div>
                  </div>
                  <div
                    class="col-lg-1 col-md-2 col-12"
                    v-for="(column, indexX) in columns"
                    :key="indexX"
                  >
                    <div
                      class="single--row-info align-items-center border-0"
                      style="color: white; text-align: center;"
                    >
                      {{ column.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="single--row-input-content"
                v-for="(indicator, indexI) in factor.indicators"
                :key="indexI"
              >
                <div class="row">
                  <div :class="'col-lg-' + colMdIndicator + ' col-md-2 col-12'">
                    <div class="single--row-info align-items-start ml-1">
                      {{ indicator.name }}
                    </div>
                  </div>
                  <div
                    class="col-lg-1 col-md-2 col-12"
                    v-for="(column, indexX) in columns"
                    :key="indexX"
                  >
                    <div
                      class="single--row-info align-items-center"
                      v-if="indicators_summary[column.type] !== undefined"
                    >
                      {{
                        indicators_summary[column.type][indexI]["final_value"][
                          column.element
                        ]
                      }}
                    </div>
                    <div class="single--row-info" v-else>
                      <!--              EMPT      -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3 mb-3 px-2">
      <div class="col-12">
        <h3 class="text-primary">
          {{ __("forms.EvaluationChart.questions.questions_setting.question18.min_max_evaluation") }}
        </h3>
        <p class="text-secondary">
          {{ __("forms.EvaluationChart.questions.questions_setting.question18.min_max_evaluation_7") }}
        </p>
        <p class="text-secondary">
          {{ __("forms.EvaluationChart.questions.questions_setting.question18.min_max_evaluation_voices") }}
        </p>
      </div>
    </div>
    <div class="row mb-3 px-3">
      <!--                Grafico media fattori-->
      <div class="col-12">
        <horizontal-bar-pnp
          ref="horizontal_bar_summary_pnp_min_indicator"
          :range="range_value"
          :title_text="min_points_label"
          :fixedLabelYAxis="true"
        ></horizontal-bar-pnp>
      </div>

      <div class="col-12" style="margin-top: 20px">
        <!--                Grafico media fattori-->

        <horizontal-bar-pnp
          ref="horizontal_bar_summary_pnp_max_indicator"
          :range="range_value"
          :title_text='max_points_label'
          :fixedLabelYAxis="true"
        ></horizontal-bar-pnp>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      //
      colMdIndicator: 12,
      range_value: { min: 0, max: 5 },
      min_points_label : this.__("forms.EvaluationChart.questions.questions_setting.question18.min_points"),
      max_points_label : this.__("forms.EvaluationChart.questions.questions_setting.question18.max_points"),
      general_avg_label: this.__("forms.EvaluationChart.questions.questions_setting.question18.general_avg"),

    };
  },
  mounted() {
    this.colMdIndicator = 12 - this.columns.length;
    this.printSummaryGraph();
  },
  methods: {

    toggle(index) {
      this.$refs[`summary_drop${index}`][0].classList.toggle("d-none");
      this.$refs[`chevron${index}`][0].classList.toggle("fa-rotate-180");
    },
    hideAll() {
      let refs = this.$refs;

      const collapseRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("summary_drop"),
      );
      console.log(collapseRefs, "collapseRefs");
      const chevronRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("chevron"),
      );
      collapseRefs.forEach((ref) => {
        this.$refs[ref][0].classList.add("d-none");
      });
      chevronRefs.forEach((ref) => {
        this.$refs[ref][0].classList.remove("fa-rotate-180");
      });
    },
    showAll() {
      let refs = this.$refs;
      console.clear();
      console.log(refs);
      const collapseRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("summary_drop"),
      );
      const chevronRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("chevron"),
      );
      collapseRefs.forEach((ref) => {
        this.$refs[ref][0].classList.remove("d-none");
      });
      chevronRefs.forEach((ref) => {
        this.$refs[ref][0].classList.add("fa-rotate-180");
      });
    },
    printSummaryGraph() {
      this.$refs.vertical_bar_summary_pnp.drawBarsGraph(
        this.data_average_graph,
      );
      this.$refs.horizontal_bar_summary_pnp_max_indicator.drawBarsGraph(
        this.data_min_max_graph.maxGraphData,
      );
      this.$refs.horizontal_bar_summary_pnp_min_indicator.drawBarsGraph(
        this.data_min_max_graph.minGraphData,
      );
    },
  },
  props: {

    avg_total_factors: {
      type: Number,
      required: true,
    },
    factors_summary: {
      type: Object,
      required: true,
    },
    indicators_summary: {
      type: Object,
      required: true,
    },
    show_types: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    elements: {
      type: Array,
      required: true,
    },
    table_summary_structure: {
      type: Object,
      required: true,
    },
    numbers_summary: {
      type: Object,
      required: true,
    },
    data_average_graph: {
      type: Object,
      required: true,
    },
    data_min_max_graph: {
      type: Object,
      required: true,
    },
    pnp_summary_column_label: {
      type: String,
      required: true,
    },
  },
};
</script>
